import React, { useRef, useState, useCallback } from 'react';
import {
  cldVideoMp4,
  cldVideoWebm,
  cldVideoPlainMp4,
  cldPosterUrl,
} from '../../utils/cloudinary';

export default function CloudinaryVideoPlayer({ publicId, caption }) {
  const poster = cldPosterUrl(publicId);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = useCallback(() => setIsPlaying(true), []);
  const handlePause = useCallback(() => setIsPlaying(false), []);
  const handleEnded = useCallback(() => setIsPlaying(false), []);

  const startPlayback = useCallback(() => {
    const vid = videoRef.current;
    if (!vid) return;
    vid.play().catch(() => {
      vid.focus();
    });
  }, []);

  return (
    <figure className='tw-m-0'>
      <div className='tw-relative tw-w-full'>
        <video
          ref={videoRef}
          controls
          playsInline
          preload='metadata'
          poster={poster}
          onPlay={handlePlay}
          onPause={handlePause}
          onEnded={handleEnded}
          className='tw-w-full tw-h-auto tw-rounded-[20px] tw-block'
        >
          <source src={cldVideoWebm(publicId)} type='video/webm' />
          <source src={cldVideoMp4(publicId)} type='video/mp4' />
          <source src={cldVideoPlainMp4(publicId)} type='video/mp4' />
          Your browser does not support the video tag.
        </video>

        {/* Overlay (shown when NOT playing) */}
        {!isPlaying && (
          <button
            type='button'
            onClick={startPlayback}
            aria-label='Play video'
            className='
              tw-absolute tw-inset-0 tw-z-10
              tw-flex tw-items-center tw-justify-center
              tw-bg-black/60
              tw-rounded-[20px]
              tw-transition-opacity tw-duration-300
              focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/50
            '
          >
            <svg
              width='104'
              height='104'
              viewBox='0 0 104 104'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect
                x='0.15'
                y='0.15'
                width='103.7'
                height='103.7'
                rx='51.85'
                stroke='white'
                strokeOpacity='0.2'
                strokeWidth='0.3'
              />
              <rect
                x='12.25'
                y='12.25'
                width='79.5'
                height='79.5'
                rx='39.75'
                stroke='white'
                strokeOpacity='0.4'
                strokeWidth='0.5'
              />
              <path
                d='M68.9541 55.5377C71.2685 53.7469 71.2685 50.2528 68.9541 48.4621C61.9598 43.0501 54.1497 38.7844 45.8161 35.8246L44.2937 35.2839C41.381 34.2495 38.3045 36.2201 37.9102 39.2267C36.8085 47.6272 36.8085 56.3725 37.9102 64.773C38.3045 67.7796 41.381 69.7503 44.2937 68.7158L45.8161 68.1751C54.1497 65.2153 61.9598 60.9496 68.9541 55.5377Z'
                fill='white'
              />
            </svg>
          </button>
        )}
      </div>
    </figure>
  );
}
